// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BackwardOutlinedSvg from "@fishx/icons-svg/es/asn/BackwardOutlined";
import FishxIcon from '../components/FishxIcon';

var BackwardOutlined = function BackwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BackwardOutlinedSvg
  }));
};

BackwardOutlined.displayName = 'BackwardOutlined';
export default React.forwardRef(BackwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BackwardOutlined.js
// module id = 2039
// module chunks = 0